<template>
  <div>
    <el-row>
      <el-col :span="18" class="text-right">
        <div class="inlineBlock mr-20">
          <div>
            <span class="username">
              <b>{{ username }}</b>
            </span>
          </div>
          <div>
            <span class="user-info">{{ faenaName(this.$store.getters.role.faena_id) }}</span>
          </div>
          <div v-if="$store.getters.role.admin">
            <span class="user-info">
              <b>{{$t('Administrador')}}</b>
            </span>
          </div>
          <div v-else>
            <div v-if="$store.getters.role.area_id && this.$route.path !== '/es/seleccionar-roles'">
              <span class="user-info">{{ areaName($store.getters.role.area_id) }}</span>
            </div>
            <div
              v-if="$store.getters.role.empresa_id && this.$route.path !== '/es/seleccionar-roles'"
            >
              <span class="user-info">{{ companyName($store.getters.role.empresa_id) }}</span>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="6" class="text-white">
        <el-button
          class="userBtn"
          type="primary"
          size="small"
          @click="signOut()"
        >{{$t('Cerrar Sesión')}}</el-button>
      </el-col>
      <!-- <el-col :span="24" class="text-right text-white">
        <div class="inlineBlock mr-20">
          <div>
            <span class="username"><b>{{ username }}</b></span>
          </div>
          <div>
            <span class="user-info">
              {{ faenaName(this.$store.getters.role.faena_id) }}
            </span>
          </div>
          <div v-if="$store.getters.role.admin">
            <span class="user-info">
              <b>{{$t('Administrador')}}  </b> 
            </span>
          </div>
          <div v-else>
            <div v-if="$store.getters.role.area_id && this.$route.path !== '/es/seleccionar-roles'">
              <span class="user-info">
                {{ areaName($store.getters.role.area_id) }}
              </span>
            </div>
            <div v-if="$store.getters.role.empresa_id && this.$route.path !== '/es/seleccionar-roles'">
              <span class="user-info">
                {{ companyName($store.getters.role.empresa_id) }}
              </span>
            </div>
          </div>
        </div>

        <div class="inlineBlock mr-20">
          <el-button
            class="userBtn"
            type="primary"
            size="small"
            @click="signOut()">
            {{$t('Cerrar Sesión')}}
          </el-button>
          <br><br>
        </div>
      </el-col>-->
    </el-row>
  </div>
</template>

<script>
import { reviewerRoles, coordinatorRoles } from "@/utils/generalObjects";

export default {
  name: "Roles",
  props: {
    roles: {
      type: Array,
      required: true
    },
    currentRole: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      reviewerRoles: {
        health: "Especialista de Salud",
        safety: "Especialista de Seguridad",
        environment: "Especialista de Medioambiente",
        contractor_hse: "HSE Contratista",
        contract_owner: "Dueño de Contrato",
        administrator: "Administrador de Contrato",
        hse: "HSE",
        owner: "Dueño de Contrato",
        risk: "Especialista de Riesgo",
        manager: "Gerente de Área",
        super: "Superintendente de Área",
        general_manager: "Gerente General"
      },
      roleDescriptionView: false,
      faena: this.currentRole.faena_id,
      admin: this.currentRole.admin,
      aeId: null,
      role: null,
      aeOptions: [],
      rolesOptions: [],
      disabledAreasEmpresas: false,
      disabledRole: false,
      changeRoleDialog: false,
      reviewerRoles,
      coordinatorRoles,
      bhpProfiles: {
        hse: "HSE",
        health: this.$t("Especialista de Salud"),
        safety: this.$t("Especialista de Seguridad"),
        environment: this.$t("Especialista de Medioambiente"),
        contractor_hse: this.$t("HSE Contratista"),
        owner: this.$t("Dueño de Contrato"),
        contract_owner: this.$t("Dueño de Contrato"),
        risk: this.$t("Especialista de Riesgo"),
        administrator: this.$t("Administrador de Contrato"),
        contractor_coordinator: this.$t("Coordinador Contratista"),
        coordinator: this.$t("Coordinador"),
        manager: this.$t("Gerente de Área"),
        super: this.$t("Superintendente de Área"),
        general_manager: this.$t("Gerente General")
      }
    };
  },
  mounted() {
    this.setAeOptions();
  },
  computed: {
    faenas() {
      return this.roles.map(r => r.faena_id);
    },
    username() {
      return `${this.$store.getters.user.nombre} ${this.$store.getters.user.apellido}`;
    },
    empresas() {
      return this.$store.getters.empresas;
    }
  },
  methods: {
    setAeOptions() {
      if (this.roles) {
        const rolesFaena = this.roles.find(rf => rf.faena_id === this.faena);
        this.aeOptions = [];
        if (rolesFaena) {
          if (rolesFaena.data.admin) {
            this.admin = true;
            this.aeId = null;
            this.role = this.$t("Administrador Plataforma");

            this.disabledAreasEmpresas = true;
            this.disabledRole = true;
          } else {
            // Obteneos Areas posibles
            if (rolesFaena.data.areas) {
              Object.keys(rolesFaena.data.areas).map(id =>
                this.aeOptions.push({ _id: id, type: "Areas" })
              );
            }
            // Obtenemos Empresas posibles
            if (rolesFaena.data.empresas) {
              Object.keys(rolesFaena.data.empresas).map(id =>
                this.aeOptions.push({ _id: id, type: "Empresas" })
              );
            }

            this.admin = false;
            this.role = null;
            this.disabledAreasEmpresas = false;
            this.disabledRole = false;
          }
        }
      }
    },
    setRolesOptions() {
      this.rolesOptions = [];
      const ae = this.aeOptions.find(i => i._id === this.aeId);

      const rolesFaena = this.roles.find(rf => rf.faena_id === this.faena);
      if (ae.type === "Areas") {
        const area = this.$store.getters.areasRoles.find(
          i => i._id === this.aeId
        );
        this.rolesOptions = rolesFaena.data.areas[ae._id].map(r => ({
          role: r,
          name: this.bhpProfiles[r]
        }));

        if (area.area_padre_id === null && ae._id != "GeneralAreasRoles") {
          this.rolesOptions.unshift({
            role: "general_manager",
            name: this.bhpProfiles["general_manager"]
          });
        } // if
      } else if (ae.type === "Empresas") {
        this.rolesOptions = rolesFaena.data.empresas[ae._id].map(r => ({
          role: r,
          name: this.bhpProfiles[r]
        }));
      } // if
    },
    async changeRole() {
      // aunque si es admin entre faenas lo que hace es cambiar de faena y no el 'rol'
      // '' * se podria mantener el 'rol' y solo cambiar de 'faena' 'area'||'empresa'
      const ae = this.aeOptions.find(i => i._id === this.aeId);
      const newRole = {
        faena_id: this.faena,
        admin: this.admin
      };
      if (!this.admin) {
        // Area o Empresa
        if (ae.type === "Areas") {
          newRole.area_id = ae._id;
        } else {
          newRole.empresa_id = ae._id;
        }
        // Role
        newRole.role = this.role;
      } // if

      // reset datos de otros roles
      await this.$store.dispatch("resetEmpresasFaena");
      await this.$store.dispatch("resetAreas");
      await this.$store.dispatch("resetContract");
      await this.$store.dispatch("resetUserContractByRole");

      await this.$store.dispatch("setRole", newRole);
      this.redirect();
      this.changeRoleDialog = false;
    },
    redirect() {
      if (this.$route.name === "homePage") {
        this.$router.push({ name: "pushIndex" });
      } else {
        this.$router.push({ name: "homePage" });
      } // if
    },
    async signOut() {
      // reset datos de otros roles
      await this.$store.dispatch("resetEmpresasFaena");
      await this.$store.dispatch("resetAreas");
      await this.$store.dispatch("resetContract");
      await this.$store.dispatch("resetUserAllContracts");
      await this.$store.dispatch("resetUserContractByRole");
      await this.$store.dispatch("latestState", null);
      await this.$store.dispatch("setAllTareasPendientes", null);

      await this.$store.dispatch("logout");
      if (window.location.hostname.includes("release.amsa.lifeon.cl")) {
        window.location = "https://release.amsa.lifeon.cl/logout";
      } else if (window.location.hostname.includes("dev.lifeon.cl")) {
        window.location = "https://bhp.amsa.lifeon.cl/logout";
      } else if (window.location.hostname.includes("localhost")) {
        this.$router.push({ name: "homePage" });
      } else {
        window.location = "https://amsa.lifeon.cl/logout";
      }
    },
    faenaName(id) {
      if (this.$store.getters.faenasRoles) {
        const f = this.$store.getters.faenasRoles.find(f => f._id === id) || {};
        return f.nombre || id;
      } else {
        return "";
      }
    },
    areaName(id) {
      if (this.$store.getters.areasRoles) {
        const area = this.$store.getters.areasRoles.find(a => a._id === id);
        return area ? area.nombre : id;
      } else {
        ("");
      }
    },
    companyName(id) {
      if (this.empresas) {
        var empresa = this.empresas.find(x => x._id === id);
        if (empresa && empresa.nombre) {
          return empresa.nombre;
        }
      } else {
        return "";
      }
    }
  }
};
</script>

<style scoped>
.userBtn {
  width: 125px;
  margin: 3px;
}
.username {
  font-weight: 800;
  font-size: 18px;
}
.user-info {
  font-size: 14px;
}
.infoLogin {
  margin-top: 14px;
}
</style>
